module.exports = __webpack_public_path__ + "static/media/Swashakthi-SHG-testimonial-3.658e3b1d.webp";